import { NgModule } from '@angular/core';
import { ChartComponent } from "./chart.component";
import { CommonModule } from "@angular/common";
import { NzCardModule } from 'ng-zorro-antd/card';
import { NgxEchartsModule } from 'ngx-echarts';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { TablesModule } from '@shared/components/tables/tables.module';

@NgModule({
  declarations: [ChartComponent],
  imports: [
    CommonModule,
    NzCardModule,
    NgxEchartsModule,
    NzButtonModule,
    NzIconModule,
    NzWaveModule,
    NzSpaceModule,
    TablesModule
  ],
  exports: [ChartComponent]
})
export class ChartModule {}
